import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  List,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { getPackages } from "../testPrepDashboard/Api/DashboardApi";

import Loader from "../../../SAPPages/components/Loader/Loader";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomPafinationComp from "../allClasses/CustomPafinationComp";
import CustomPopup from "../../components/customPopup/CustomPopup";
import DateAndClassInfo from "./DateAndClassInfo";

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const EnrolmentStepOne = ({ onNext }) => {
  const userId = localStorage.getItem("userId");
  const navigate =useNavigate()
  const [selectedSlot, setSelectedSlot] = useState("Simran");
  const [packagesData, setPackagesData] = useState([]);
  const [packagesLoading, setPackagesLoading] = useState(true);
  const [pagination, setPagination] = useState(null);
  const location = useLocation();
  const { classData } = location.state || [];
  const [page, setPage] = useState(1);
  const [opendatePopup, setOpenDatePopup] = useState(false);
  const [selectedPackgeData, setSelectedPackgeData] = useState(null);

  console.log("classData",classData)
  const handleNext = () => {
    if (!selectedSlot) return alert("Please select a slot.");
    onNext({ selectedSlot });
  };

  const [hoveredIndex, setHoveredIndex] = useState(null); // Track which button is hovered

  const handlefetchPackagesData = async (page) => {
    setPackagesLoading(true);
    try {
      const response = await getPackages({
        test_type_id: classData?.test_type_id?.id,
        limit: 6,
        page,
        user_id: parseInt(userId),
      });

      setPackagesData(response.data || []);
      setPagination(response?.pagination);
      setPackagesLoading(false);
    } catch (error) {
      console.error("Error fetching classes:", error);
      setPackagesLoading(false);
    }
  };

  useEffect(() => {
    handlefetchPackagesData(page);
  }, [page]);

  const handleOpendatePopup = (packageData) => {
    setOpenDatePopup(true);
    setSelectedPackgeData(packageData);
  };

  const handleClosedatePopup = () => {
    setOpenDatePopup(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={5.6} ml={2} mt={1} container gap={3} alignItems="center">
           <ArrowBackIosNewIcon
            style={{ color: '#572575', cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          />
          <Typography
            textAlign="start"
            color="#111111"
            fontFamily="Inter"
            fontSize="24px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 400 }}
          >
            Class {" "} Details
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          ml={2}
          mt={1}
          container
          direction="row"
          alignItems="center"
          gap={1}
          justifyContent="end"
        >
          <InfoOutlinedIcon style={{ color: "#FAAE2D" }} />
          <Typography
            fontSize="12px"
            color="#111111"
            fontFamily="Inter"
            lineHeight="100%"
            letterSpacing="0%"
          >
            Review your class information and select a package to proceed.
          </Typography>
        </Grid>

        {/* Class Details */}
        <Grid item xs={12} mt={2} mx={2} height="100%">
          <Box
            sx={{
              border: "1px solid #DDDDDD",
              padding: { xs: 1, sm: 2, md: 2 },
              px: { xs: 1, sm: 2, md: 4 },
              width: "100%",
              borderRadius: "6px",
            }}
          >
            <Grid container height="100%">
              <Grid item xs={12} sm={12} md={9}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    container
                    alignItems="center"
                    flexDirection="row"
                    gap={1}
                  >
                    <Box width={40}>
                      <img src="/newdashboard/Checkout/graduate_7917737 1.png"></img>
                    </Box>
                    <Typography
                      textAlign="start"
                      color="#9D0385"
                      fontFamily="Inter"
                      fontSize="20px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                    >
                      {classData?.test_type_id?.name}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={6}>
                        <Box
                          display="flex"
                          alignItems="center"
                          flexDirection="row"
                          gap={1}
                        >
                          <Box width={30}>
                            <img src="/newdashboard/Checkout/Group 1171283449.png" />
                          </Box>
                          <Typography
                            textAlign="start"
                            color="#444444"
                            fontFamily="Inter"
                            fontSize="14px"
                            lineHeight="100%"
                            letterSpacing="0px"
                            fontStyle="normal"
                            style={{ fontWeight: 400 }}
                          >
                            Time :{" "}
                            <span style={{ color: "#000000" }}>
                              {" "}
                              {classData?.start_time}- {classData?.end_time}
                            </span>
                          </Typography>
                        </Box>
                      </Grid>

{classData?.trainer_id?.work_experience && (
                      <Grid item xs={12} sm={6} md={6}>
                        <Box
                          display="flex"
                          alignItems="center"
                          flexDirection="row"
                          gap={1}
                        >
                          <Box width={30}>
                            <img src="/newdashboard/Checkout/Group 1171283449 (1).png" />
                          </Box>
                          <Typography
                            textAlign="start"
                            color="#444444"
                            fontFamily="Inter"
                            fontSize="14px"
                            lineHeight="100%"
                            letterSpacing="0px"
                            fontStyle="normal"
                            style={{ fontWeight: 400 }}
                          >
                           Trainer Work Experience :{" "}
                            <span style={{ color: "#000000" }}>
                              {" "}
                             {classData?.trainer_id?.work_experience } Years
                            </span>
                          </Typography>
                        </Box>
                      </Grid>
                       )}

                      <Grid item xs={12} sm={6} md={6}>
                        <Box
                          display="flex"
                          alignItems="center"
                          flexDirection="row"
                          gap={1}
                        >
                          <Box width={30} flexShrink={0}>
                            <img src="/newdashboard/Checkout/Group 1171283449 (1).png" />
                          </Box>
                          <Typography
                            textAlign="start"
                            color="#444444"
                            fontFamily="Inter"
                            fontSize="14px"
                            lineHeight="1.4"
                            letterSpacing="0px"
                            fontStyle="normal"
                            style={{ fontWeight: 400 }}
                          >
                            Trainer Expertise :{" "}
                            <span style={{ color: "#000000" }}>
                              {" "}
                              {classData?.trainer_id?.trainer_expertise?.join(", ")}{" "}
                              
                            </span>
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6} md={6}>
                        <Box
                          display="flex"
                          alignItems="center"
                          flexDirection="row"
                          gap={1}
                        >
                          <Box width={30}>
                            <img src="/newdashboard/Checkout/Group 1171283449 (2).png" />
                          </Box>
                          <Typography
                            textAlign="start"
                            color="#444444"
                            fontFamily="Inter"
                            fontSize="14px"
                            lineHeight="100%"
                            letterSpacing="0px"
                            fontStyle="normal"
                            style={{ fontWeight: 400 }}
                          >
                            Mode :{" "}
                            <span style={{ color: "#000000" }}>
                              {" "}
                              {classData?.mode_of_delivery === "offline"
                                ? "Offline"
                                : "Online"}
                            </span>
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6} md={6}>
                        <Box
                          display="flex"
                          alignItems="center"
                          flexDirection="row"
                          gap={1}
                        >
                          <Box width={30}>
                            <img src="/newdashboard/Checkout/Group 1171283449 (3).png" />
                          </Box>
                          <Typography
                            textAlign="start"
                            color="#444444"
                            fontFamily="Inter"
                            fontSize="14px"
                            lineHeight="100%"
                            letterSpacing="0px"
                            fontStyle="normal"
                            style={{ fontWeight: 400 }}
                          >
                            Class Days :{" "}
                            <span style={{ color: "#000000" }}>
                              {classData?.day?.map((day) => day).join(", ")}
                            </span>
                          </Typography>
                        </Box>
                      </Grid>

                      {classData?.mode_of_delivery === "offline" && (
                        <>
                          <Grid item xs={12} sm={6} md={6}>
                            <Box
                              display="flex"
                              alignItems="center"
                              flexDirection="row"
                              gap={1}
                            >
                              <Box width={30}>
                                <img src="/newdashboard/Checkout/Group 1171283449 (4).png" />
                              </Box>
                              <Typography
                                textAlign="start"
                                color="#444444"
                                fontFamily="Inter"
                                fontSize="14px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                Branch :{" "}
                                <span style={{ color: "#000000" }}>
                                  {" "}
                                  {classData?.branch_id?.branch_name}
                                </span>
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={12} md={12}>
                            <Box
                              display="flex"
                              alignItems="center"
                              flexDirection="row"
                              gap={1}
                            >
                              <Box width={30} flexShrink={0}>
                                <img src="/newdashboard/Checkout/Group 1171283449 (4).png" />
                              </Box>
                              <Typography
                                textAlign="start"
                                color="#444444"
                                fontFamily="Inter"
                                fontSize="14px"
                                lineHeight="1.4"
                                letterSpacing="0.1px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                Location :{" "}
                                <span style={{ color: "#000000" }}>
                                  {" "}
                                  {classData?.branch_id?.address}
                                </span>
                              </Typography>
                            </Box>
                          </Grid>
                        </>
                      )}

                      {classData?.mode_of_delivery === "online" && (
                        <Grid item xs={12} sm={6} md={6}>
                          <Box
                            display="flex"
                            alignItems="center"
                            flexDirection="row"
                            gap={1}
                          >
                            <Box width={30}>
                              <img src="/newdashboard/Checkout/Group 1171283449 (4).png" />
                            </Box>
                            <Typography
                              textAlign="start"
                              color="#444444"
                              fontFamily="Inter"
                              fontSize="14px"
                              lineHeight="100%"
                              letterSpacing="0px"
                              fontStyle="normal"
                              style={{ fontWeight: 400 }}
                            >
                              Branch :{" "}
                              <span style={{ color: "#000000" }}>
                                {" "}
                                Online Class
                              </span>
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: { xs: "none", md: "flex" },
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box>
                  <img
                    src={classData?.image_path?.image_src}
                    alt={classData?.test_type_id?.name}
                    style={{ maxWidth: "100%", borderRadius: "12px" }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item xs={12} mx={2}>
          <Box
            sx={{
              border: "1px solid #DDDDDD",
              p: { xs: 1, sm: 2, md: 4 },
              width: "100%",
              borderRadius: "6px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  justifyContent="center"
                >
                  <Box width={30}>
                    <img src="/newdashboard/Checkout/material-symbols_crown-rounded.png" />
                  </Box>
                  <Typography
                    color="#572575"
                    fontFamily="Inter"
                    fontSize="20px"
                    lineHeight="1.4"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 600 }}
                  >
                    Choose Your Preferred Package
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} mt={2}>
                <Grid container spacing={3}>
                  {packagesLoading ? (
                    <Grid item xs={12}>
                      <Loader text="Loading Packges..." height="20vh" />
                    </Grid>
                  ) : !packagesLoading && packagesData?.length===0 ? (
                    <Grid item xs={12} container justifyContent="center" alignItems="center" flexDirection="column">
                   <Box><img src="/newdashboard/Checkout/47718912_9169251 1.png"/></Box>
                      <Typography  color="#9D0385"
                    fontFamily="Inter"
                    fontSize="20px"
                    lineHeight="1.4"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}>No Package Available</Typography>
                         <Typography mt={2} color="#555555"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="1.4"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 700 }}>Currently, there are no packages available for this class. </Typography>
                           <Typography mt={1} color="#333333"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="1.4"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}>Please check back later or choose another class. </Typography>
                    </Grid>
                  ):(
                    packagesData?.map((item, index) => (
                      <Grid item xs={12} sm={12} md={4} >
                        <Card
                       
                          sx={{
                            border: "1px solid #DDDDDD",
                            cursor: "pointer",
                            padding: "10px",
                            width: "100%",
                            height:"100%",
                            borderRadius: "8px",
                 display: "flex",          // flex container
    flexDirection: "column",  // stack vertically
                            px: { xs: 1, sm: 1, md: 1.5 },
                            "&:hover": {
                              border: "1px solid #E7CEF6",
                              boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
                            },
                          }}
                        >
                          
                           <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                          <Box display="flex" alignItems="center" >
                              <Box width={30}>
                                <img src="/newdashboard/Checkout/Group 1171283405.png" />
                              </Box>
                             
                              <Typography
                                color="#9D0385"
                                fontFamily="Inter"
                                fontSize="16px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontStyle="normal"
                                ml={0.5}
                                style={{ fontWeight: 700 }}
                              >
                                {item?.package_name}
                              </Typography> </Box>
                          

                           <Box p={1}>
                              <Typography
                                color="#572575"
                                fontFamily="Inter"
                                fontSize="22px"
                                lineHeight="100%"
                                letterSpacing="0%"
                                mt={1}
                                style={{ fontWeight: 700 }}
                              >
                                {item?.currency} {item?.original_price}
                              </Typography>
                           

                            <List style={{marginLeft:0}}>
                              {item?.description
                                ?.split(";")
                                .map((descPart, idx) => {
                                  const trimmed = descPart.trim();
                                  if (!trimmed) return null; // skip empty parts
                                  return (
                                    <ListItem key={idx} sx={{ py: 0.5, width:'100%', ml:"-20px" }}>
                                      <ListItemIcon
                                        sx={{
                                          minWidth: "20px",
                                          height: "20px",
                                          color: "#070706ff",
                                        }}
                                      >
                                        <img
                                          src="/newdashboard/Checkout/Vector.png"
                                          alt=""
                                        />
                                      </ListItemIcon>
                                      <Typography
                                        fontSize="12px"
                                        color="#333333"
                                        fontFamily="Inter"
                                        fontWeight={400}
                                        lineHeight="1.4"
                                        ml={0.5}
                                      >
                                        {trimmed}
                                      </Typography>
                                    </ListItem>
                                  );
                                })}
                            </List>
                            </Box>
</Box>

                            
                              <Button
                                variant="outlined"
                                onClick={() => handleOpendatePopup(item)}
                                startIcon={
                                  hoveredIndex === index ? (
                                    <img
                                      src="/newdashboard/Checkout/ic_round-co-present.png"
                                      alt="Hover Icon"
                                      style={{ width: 20, height: 20 }}
                                    />
                                  ) : (
                                    <img
                                      src="/newdashboard/Checkout/fa7-solid_paper-plane.png"
                                      alt="Default Icon"
                                    />
                                  )
                                }
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                sx={{
                                  borderColor: "#E7CEF6", // purple border
                                  color: "#572575", // text & icon color
                                  borderRadius: "6px", // rounded corners
                                  padding: "10px 20px",
                                  textTransform: "none", // disable uppercase
                                  fontWeight: 700,
                                  boxShadow:
                                    "0px 4px 8px rgba(162, 89, 255, 0.2)",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  width: "100%",
                                  height: "32px",
                                 mt:1,
                                  "&:hover": {
                                    borderColor: "#A259FF",
                                    backgroundColor: "#572575", // light hover
                                    color: "#FFFFFF",
                                  },
                                }}
                              >
                                Start Learning
                              </Button>
                         
                        

                        </Card>
                      </Grid>
                    ))
                  )}
                  <Grid item xs={12}>
                    {pagination && packagesData?.length>0 && (
                      <CustomPafinationComp
                        currentPage={pagination?.current_page}
                        totalPages={pagination?.total_page}
                        onPageChange={setPage}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {/* Your form content here */}
      {/* <Box mt={4} display="flex" justifyContent="flex-end">
        <Button variant="contained" onClick={handleNext}>Next</Button>
      </Box> */}

      <CustomPopup
        handleClose={handleClosedatePopup}
        component={
          <DateAndClassInfo
            handleClose={handleClosedatePopup}
            classData={classData}
            packageData={selectedPackgeData}
          />
        }
        open={opendatePopup}
        titleColor="#000000"
        maxWidth="sm"
        titleAlign="center"
      />
    </>
  );
};

export default EnrolmentStepOne;
